<template>
  <div class="layout-user-login-history"
       v-loading="loading"
       element-loading-text="登录历史加载中，请稍等...">
    <div class="user-login-history-cont" v-if="loginHistoryData">
      <DataGrid :data="loginHistoryData"
                style="width: 100%"
                height="100%"
                size="mini"
                resizable
                row-class-name="console-font"
                highlight-hover-row>
        <DataGridColumn
          type="seq"
          align="right"
          width="40">
        </DataGridColumn>
        <DataGridColumn
          field="loginDate"
          title="登录时间"
          align="center"
          width="180">
        </DataGridColumn>
        <DataGridColumn
          field="loginIp"
          title="登录IP"
          align="center"
          width="200">
        </DataGridColumn>
        <DataGridColumn
          field="userAgent"
          title="UA"
          min-width="300">
        </DataGridColumn>
        <span slot="empty">登录历史记录为空</span>
      </DataGrid>
    </div>
  </div>
</template>

<script>
import DataGrid from '../elements/DataGrid'
import DataGridColumn from '../elements/DataGridColumn'
export default {
  name: 'UserLoginHistory',
  components: {DataGrid, DataGridColumn},
  data () {
    return {
      loading: false,
      loginHistoryData: null
    }
  },
  methods: {
    loadLoginHistory () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/center/loginHistory',
        method: 'post',
        disableErrorPage: true
      }).then((response) => {
        if (response.data) {
          this.loginHistoryData = response.data['loginHistoryData']
        }
      }, () => {
        this.$message.error({
          message: '请求发送失败，请稍后重试',
          center: true
        })
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadLoginHistory()
  }
}
</script>

<style lang="scss">
  .layout-user-login-history {
    height: 100%;
    background-color: #fff;
    .user-login-history-cont {
      height: 100%;
      .el-table {
        &:before,
        &:after {
          background-color: transparent;
        }
        .el-table__header-wrapper {
          .cell {
            color: #606266;
          }
        }
        .el-table__empty-block {
          min-height: 120px;
          & > .el-table__empty-text {
            line-height: 120px;
          }
        }
      }
    }
  }
</style>
